import { qs, delegate, on } from '../helpers';

export default class InputOptions {
    constructor(container) {
        this.container = container;

        this.input = qs('input', this.container);
        this.input.readOnly = true;
        this.options = qs('.options', this.container);
        this.caretDown = qs('.caret.caret-down', this.container);
        this.caretUp = qs('.caret.caret-up', this.container);

        this.setupClickListeners();
    }

    setupClickListeners() {

        // show options on input click
        on(this.input, "click", () => {
            this.options.classList.toggle('visible');
            this.toggleCaret();
        });

        // on an option click, set input to that option
        delegate(this.options, '.option', "click", ({ target }) => {
            this.input.value = target.innerText;
            this.options.classList.remove('visible');
            this.toggleCaret();
        })

        // hide options when clicked outside of the options container
        on(document, "click", (e) => {
            if (e.target != this.input) {
                this.options.classList.remove('visible');
                this.toggleCaret("down");
            }
        })
    }

    toggleCaret(direction = null) {
        if (direction == "down") {
            this.caretDown.classList.add('visible');
            this.caretUp.classList.remove('visible');
            return;
        }
        this.caretDown.classList.toggle('visible');
        this.caretUp.classList.toggle('visible');
    }
}